import {Injectable} from '@angular/core';
import {MyStorageService} from './my-storage.service';
import {Constants} from '../../utils/constants';
import {Router} from '@angular/router';
import {Utilities} from '../../utils/utilities';

@Injectable({
    providedIn: 'root'
})
export class WebsocketNotificationService {
    public static NOTIFICATION_COOKIE_KEY = Constants.NOTIFICATION_KEY;
    public static DRAFT_COOKIE_KEY = Constants.DRAFT_NOTIFICATION_KEY;
    public static DASHBOARD_MESSAGE_COOKIE_KEY = Constants.DASHBOARD_MESSAGE_COOKIE_KEY;
    public static NOTIFICATION_TYPE_BLACK_LIST = [
        'STATUS_CHANGE_DELIVERY',
        'STATUS_CHANGE_ACCEPT',
        'STATUS_CHANGE_PENDING',
        'STATUS_CHANGE_SUCCESS',
        'STATUS_CHANGE_NOT_ARRIVED',
        'UPDATE_GUEST',
        'ADD_NOTE',
    ];

    private _reservationEndpoint = '/output/reservation';
    private _orderEndpoint = '/output/order';
    private _closingHoursEndpoint = '/output/closing-hours';
    private _eventEndpoint = '/output/makery-event';
    private _dashboardMessageEndpoint = '/output/dashboard-message';

    public notificationElements = new Map<string, Map<string, NotificationData>>();
    public unreadCount = 0;

    constructor(private router: Router, private myStorage: MyStorageService) {
        this.notificationElements.set(WebsocketNotificationService.NOTIFICATION_COOKIE_KEY, new Map<string, NotificationData>())
        this.notificationElements.set(WebsocketNotificationService.DRAFT_COOKIE_KEY, new Map<string, NotificationData>())
        this.notificationElements.set(WebsocketNotificationService.DASHBOARD_MESSAGE_COOKIE_KEY, new Map<string, NotificationData>())
    }

    addNotification(data: BroadcastPayload, cookieKey, read: boolean = false) {
        this.getNotifications(cookieKey);
        let newNotification = new NotificationData(data.attribute.id, data);
        newNotification.read = read;
        const b = cookieKey == WebsocketNotificationService.DASHBOARD_MESSAGE_COOKIE_KEY;
        const b1 = this.notificationElements.get(cookieKey).has(data.attribute.id.toString());
        if (b && b1) {
            newNotification = this.notificationElements.get(cookieKey).get(data.attribute.id.toString());
            newNotification.read = true;
        }
        this.notificationElements.get(cookieKey).set(data.attribute.id.toString(), newNotification);
        this.myStorage.saveToStore(cookieKey, Utilities.mapToObject(this.notificationElements.get(cookieKey)));
        this.countUnread(cookieKey);
    };

    readNotification(eventData: any) {
        this.getNotifications(eventData.cookieKey);
        this.notificationElements.get(eventData.cookieKey).get(eventData.key.toString()).read = true;
        this.myStorage.saveToStore(eventData.cookieKey, Utilities.mapToObject(this.notificationElements.get(eventData.cookieKey)));
        this.countUnread(eventData.cookieKey);
        this.router.navigate([eventData.link]);
    }

    readDraftReservationNotification(eventData: any) {
        this.getNotifications(eventData.cookieKey);
        this.router.navigate([eventData.link]);
    }

    getNotificationByKey(key: any, cookieKey) {
        this.getNotifications(cookieKey);
        return this.notificationElements.get(cookieKey).get(key.toString());
    }

    deleteNotification(key, cookieKey) {
        this.getNotifications(cookieKey);
        this.notificationElements.get(cookieKey).delete(key.toString());
        this.myStorage.saveToStore(cookieKey, Utilities.mapToObject(this.notificationElements.get(cookieKey)));
        this.countUnread(cookieKey);
    }

    deleteAllNotification(cookieKey) {
        this.myStorage.saveToStore(cookieKey, Utilities.mapToObject(new Map<string, NotificationData>()));
        this.notificationElements.set(cookieKey, new Map<string, NotificationData>());
        this.countUnread(cookieKey);
    }

    public getNotifications(cookieKey) {
        this.notificationElements.set(cookieKey, Utilities.objectToMap<NotificationData>(this.myStorage.getFromStore(cookieKey, {})));
        this.countUnread(cookieKey);
    }

    countUnread(cookieKey) {
        this.unreadCount = 0;
        this.notificationElements.get(cookieKey).forEach(notification => {
            if (!notification.read) {
                this.unreadCount++;
            }
        });
    }


    get reservationEndpoint(): string {
        return this._reservationEndpoint;
    }

    get orderEndpoint(): string {
        return this._orderEndpoint;
    }

    get closingHoursEndpoint(): string {
        return this._closingHoursEndpoint;
    }

    get eventEndpoint(): string {
        return this._eventEndpoint;
    }

    get dashboardMessageEndpoint(): string {
        return this._dashboardMessageEndpoint;
    }
}

export interface BroadcastPayload {
    type: string;
    subscribePath: string;
    subscriber: string;
    attribute: any;
}

export class NotificationData {
    key: string;
    read = false;
    data: BroadcastPayload;
    createdAt;

    constructor(key: string, data: BroadcastPayload) {
        this.key = key;
        this.read = false;
        this.data = data;
        this.createdAt = Date.now();
    }
}
